import { ApiProperty } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { IsString, IsUUID } from 'class-validator';
import { BoardPurchaseCheckCountNoteCreatableInterface } from '../interfaces/board-purchase-check-count-note-creatable.interface';

@Exclude()
export class BoardPurchaseCheckCountNoteCreateDto
  implements BoardPurchaseCheckCountNoteCreatableInterface
{
  @ApiProperty({
    title: 'note',
    description: 'note',
  })
  @IsString()
  @Expose()
  text!: string;

  @ApiProperty({
    title: 'boardPurchaseId',
    description: 'boardPurchaseId',
  })
  @IsUUID()
  @Expose()
  boardPurchaseId!: string;
}
